import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function VerticalVsHorizontalScaling() {
    return (
        <TopicLayout
            title="Vertical vs. horizontal scaling"
            intro="Meet more demand by making one machine bigger, or by adding more machines and spreading the load across them. Horizontal scaling buys redundancy along with capacity, at the cost of coordination."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={140} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Vertical — bigger machine</text>
                    <Box x={60} y={50} width={60} height={40} label="App"/>
                    <Arrow x1={120} y1={70} x2={170} y2={70} label="scale up"/>
                    <Box x={170} y={30} width={100} height={80} label="App" sublabel="more CPU/RAM" accent/>

                    <line x1={300} y1={10} x2={300} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={430} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Horizontal — more machines</text>
                    <Box x={380} y={30} width={100} height={34} label="Load balancer" accent/>
                    <Box x={330} y={130} width={60} height={34} label="Node"/>
                    <Box x={410} y={130} width={60} height={34} label="Node"/>
                    <Box x={490} y={130} width={60} height={34} label="Node"/>
                    <Arrow x1={420} y1={64} x2={365} y2={130}/>
                    <Arrow x1={430} y1={64} x2={440} y2={130}/>
                    <Arrow x1={440} y1={64} x2={515} y2={130}/>
                </Diagram>
            }
            useWhen={[
                'Vertical: a larger machine can meet near-term demand with minimal application change.',
                'Horizontal: load or availability requirements exceed one machine and work can be distributed safely.'
            ]}
            tradeOff="Vertical scaling is simple but has a hardware ceiling and remains a failure domain. Horizontal scaling adds capacity and redundancy, but requires load balancing, coordination and deliberate state management; sessions and durable data cannot live only on one application instance."
            ruleOfThumb="Scale up to buy time early, then scale out when measurements or fault-tolerance goals require it; design instances to be replaceable and operations to be idempotent."
        />
    )
}
